import { useId } from 'react'
import type { KnownName } from '../../lib/catalog'
import { useNameSuggestions } from '../../hooks/useNameSuggestions'
import { useAutoFocus } from '../../hooks/useAutoFocus'

// A name field that suggests the household's own names while you type, the
// way quick add does: what's on the list, then what was bought before
// (lib/search.ts ranking). Picking one fills the field. The choices sheet's
// row editor and the import review both use it, so a recipe's ingredient can
// be pointed at the name the household already uses (lib/catalog.ts knownNames).

export function NameField({ label, value, known, onChange, autoFocus = false }: {
  label: string
  value: string
  known: KnownName[]
  onChange: (name: string) => void
  autoFocus?: boolean
}) {
  const id = useId()
  const focusRef = useAutoFocus<HTMLInputElement>(autoFocus)
  const { suggestions } = useNameSuggestions(value, known)

  return (
    <div className="ml-field ml-namefield">
      <label className="ml-label" htmlFor={id}>{label}</label>
      <input ref={focusRef} id={id} className="ml-input" value={value} autoComplete="off"
        onChange={e => onChange(e.target.value)} />
      {suggestions.length > 0 && (
        <ul className="ml-namefield__list" aria-label={`Names you use for ${value.trim() || 'this'}`}>
          {suggestions.map(k => (
            <li key={`${k.where}-${k.name}`}>
              <button type="button" className="ml-namefield__option" aria-label={`${k.name}, ${k.where}`} onClick={() => onChange(k.name)}>
                <span>{k.name}</span>
                <span className="ml-caption">{k.where}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

